var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#182e63",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.54 108.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xitecloud-symbol_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.47,23C50.27,16,48.34,3.14,47.64,0A54.13,54.13,0,0,0,37.42,2.29C34.78,21,19.93,16.45,16.39,15.08c-.45.44-.88.91-1.32,1.37C24.14,29.24,37.47,23,37.47,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.78,35.16c5.2,5.07,22.91,14.71,39.66,1.59C76.89,25.43,74.79,7.8,73.94,3.18A53.45,53.45,0,0,0,62.78.23c1.38,4.49,4.27,18.15-8.16,27.28-15,11.05-29.19,3-33.82-1.73a15.36,15.36,0,0,0-9.73-4.61,54.29,54.29,0,0,0-5.13,8.18C14.31,27.68,22.78,35.16,22.78,35.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.58,57C47,80.61,74,69.35,74,69.35c26.4-10.24,28.73-34.47,28.91-40.19A54.71,54.71,0,0,0,86.52,10C101.93,43.38,73,59.4,73,59.4,52.29,69.67,36.72,62,25.09,49c-10.34-11.48-21.63-7-24-5.93A55,55,0,0,0,0,54c0,.11,0,.21,0,.32C14.19,45.92,25.58,57,25.58,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75,80.74C14.93,69.67,3.42,66.47,1.36,66a54.13,54.13,0,0,0,5.2,14c6.53-1.57,21,1,26.86,4.91s15.73,7.66,15.73,7.66a57.22,57.22,0,0,0,47.74-4.4,54.07,54.07,0,0,0,11.65-27.87C91.4,90,48.08,92.86,30.75,80.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.83,107.67c-.47,0-.94,0-1.42,0a20.34,20.34,0,0,1-14-5.53l-.28-.27h0A33,33,0,0,0,17,93.74a63.82,63.82,0,0,0,7.28,5.73h0S33.67,106,45,107.69h0a48.11,48.11,0,0,0,7.66.77A56.2,56.2,0,0,0,63.83,107.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logo-symbol.1c6d00997e5a8933fd68d1933c66b766.svg";
export { ForwardRef as ReactComponent };